// Who's In — live status board with manager force-punch.

import { useEffect, useState } from 'react';
import { api } from '../../api';

function fmtElapsed(seconds) {
  if (seconds == null) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h === 0) return `${m}m`;
  return `${h}h ${String(m).padStart(2, '0')}m`;
}
function fmtTime(s) {
  if (!s) return '';
  return new Date(s + (s.endsWith('Z') ? '' : 'Z')).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export default function WhosInPage() {
  const [data, setData] = useState({ in: [], out: [] });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [filter, setFilter] = useState('');

  function load() {
    api.whosIn().then(setData).catch(e => setErr(e.message));
  }
  useEffect(() => {
    load();
    const id = setInterval(load, 30 * 1000);
    return () => clearInterval(id);
  }, []);

  async function force(userId, action) {
    const reason = window.prompt(`Reason for force-punch ${action}:`);
    if (!reason) return;
    setBusy(true);
    try { await api.forcePunch({ user_id: userId, action, reason }); load(); }
    catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  }

  const inFiltered = data.in.filter(r => !filter || r.full_name.toLowerCase().includes(filter.toLowerCase()));
  const outFiltered = data.out.filter(r => !filter || r.full_name.toLowerCase().includes(filter.toLowerCase()));

  return (
    <div className="page whos-in-page">
      <div className="page-header">
        <h2>Who's In</h2>
        <div className="filter-bar">
          <input type="text" placeholder="Search employees…" value={filter} onChange={e => setFilter(e.target.value)} />
        </div>
      </div>
      {err && <div className="error-banner">{err}</div>}

      <div className="whos-in-grid">
        <section>
          <h3>On the clock ({inFiltered.length})</h3>
          <table className="data-table">
            <thead>
              <tr><th>Employee</th><th>Station</th><th>Time In</th><th>Elapsed</th><th></th><th></th></tr>
            </thead>
            <tbody>
              {inFiltered.map(r => (
                <tr key={r.id}>
                  <td>{r.full_name}</td>
                  <td className="muted">{r.station_name || '—'}</td>
                  <td>{fmtTime(r.clock_in_at)}</td>
                  <td><strong>{fmtElapsed(r.elapsed_seconds)}</strong>{r.on_break ? <span className="who-clocked-in-break">on break</span> : null}</td>
                  <td><button className="btn-secondary" onClick={() => force(r.user_id, 'out')} disabled={busy}>Punch Out</button></td>
                </tr>
              ))}
              {inFiltered.length === 0 && <tr><td colSpan="5" className="empty">No one on the clock.</td></tr>}
            </tbody>
          </table>
        </section>

        <section>
          <h3>Off the clock ({outFiltered.length})</h3>
          <table className="data-table">
            <thead>
              <tr><th>Employee</th><th></th></tr>
            </thead>
            <tbody>
              {outFiltered.map(u => (
                <tr key={u.id}>
                  <td>{u.full_name}</td>
                  <td><button className="btn-secondary" onClick={() => force(u.id, 'in')} disabled={busy}>Punch In</button></td>
                </tr>
              ))}
              {outFiltered.length === 0 && <tr><td colSpan="2" className="empty">Everyone is on the clock.</td></tr>}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
}
